import { IEventMarketCsFromWS } from '@/types/event';
import { BetSelection } from '@/constants';
import { AbstractMarket } from '@/models/abstractMarket';

export class MarketCsItem extends AbstractMarket {
    public price: string;
    public score: string;
    public bookmakerId: number;
    public priceList: [number, number][];
    public feedCount: number;

    constructor(data: IEventMarketCsFromWS) {
        super();

        this.setPreviousPrice(BetSelection.Cs, data.price_max);

        this.price = data.price_max;
        this.score = data.score;
        this.bookmakerId = data.price_max_site_id;
        this.priceList = data.price_list ? JSON.parse(data.price_list) : null;
        this.feedCount = data.feeds_count;
    }

    public update(data: IEventMarketCsFromWS) {
        this.setPreviousPrice(BetSelection.Cs, this.price);

        this.price = data.price_max;
        this.score = data.score;
        this.bookmakerId = data.price_max_site_id;
        this.priceList = data.price_list ? JSON.parse(data.price_list) : null;
        this.feedCount = data.feeds_count;
    }
}
